import Badge from "@/components/core/badge.tsx";
import DataInputTable from "@/components/core/data-input-table";
import DataTable, { type ColumnDef } from "@/components/core/data-table.tsx";
import DragDropFile from "@/components/core/forms/drag-drop-file";
import { Input } from "@/components/core/forms/input";
import { Content } from "@/components/layouts/content";
import { Header } from "@/components/layouts/header";
import { formatDate } from "@/utils/format-date.ts";
import { IconSortDescending } from "@tabler/icons-react";
import { Link, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/tibol")({
	component: Page,
});

type Case = {
	name: string;
	status: string;
	case_type: string;
	case_priority: string;
	case_age: string;
	case_stage: string;
	location: string;
	updated_at: string; // or `Date` if you want to handle dates directly
};
const cases: Case[] = [
	{
		name: "CASE-001",
		status: "Pending",
		case_type: "Criminal",
		case_priority: "High",
		case_age: "15 days",
		case_stage: "Pre-Trial",
		location: "Mandaluyong",
		updated_at: "2025-01-10",
	},
	{
		name: "CASE-002",
		status: "Pending",
		case_type: "Civil",
		case_priority: "Medium",
		case_age: "30 days",
		case_stage: "Filing",
		location: "Makati",
		updated_at: "2025-01-08",
	},
	{
		name: "CASE-003",
		status: "Pending",
		case_type: "Family",
		case_priority: "Low",
		case_age: "45 days",
		case_stage: "Hearing",
		location: "Antipolo",
		updated_at: "2025-01-05",
	},
	{
		name: "CASE-004",
		status: "Resolved",
		case_type: "Criminal",
		case_priority: "High",
		case_age: "60 days",
		case_stage: "Closed",
		location: "Pasig",
		updated_at: "2025-01-02",
	},
	{
		name: "CASE-005",
		status: "Ongoing",
		case_type: "Labor",
		case_priority: "Medium",
		case_age: "10 days",
		case_stage: "Trial",
		location: "Quezon City",
		updated_at: "2025-01-09",
	},
];

const columns: ColumnDef<Case>[] = [
	{
		id: "name",
		label: "Name",
		headerClassName: "",
		cellClassName: "",
		cell: ({ data }) => (
			<Input
				className="text-left text-foreground p-3 focus:outline focus:outline-2 focus:outline-primary-600 focus:outline-offset-[-2px]"
				placeholder=""
				value={data.name}
			/>
		),
		footLabel: "Total",
		footClassName: "",
	},
	{
		id: "case_type",
		label: "Type",
		headerClassName: "",
		cellClassName: "",
		cell: ({ data }) => (
			<Input
				className="text-left text-foreground p-3 focus:outline focus:outline-2 focus:outline-primary-600 focus:outline-offset-[-2px]"
				placeholder=""
				value={data.case_type}
			/>
		),
		footLabel: "",
		footClassName: "",
	},
	{
		id: "case_priority",
		label: "Priority",
		headerClassName: "",
		cellClassName: "",
		cell: ({ data }) => (
			<Input
				className="text-left text-foreground p-3 focus:outline focus:outline-2 focus:outline-primary-600 focus:outline-offset-[-2px]"
				placeholder=""
				value={data.case_priority}
			/>
		),
		footLabel: "",
		footClassName: "",
	},
	{
		id: "status",
		label: "Status",
		headerClassName: "",
		cellClassName: "",
		cell: ({ data }) => (
			<Input
				className="text-left text-foreground p-3 focus:outline focus:outline-2 focus:outline-primary-600 focus:outline-offset-[-2px]"
				placeholder=""
				value={data.status}
			/>
		),
		footLabel: "",
		footClassName: "",
	},
	{
		id: "case_stage",
		label: "Current Stage",
		headerClassName: "",
		cellClassName: "",
		cell: ({ data }) => (
			<Input
				className="text-left text-foreground p-3 focus:outline focus:outline-2 focus:outline-primary-600 focus:outline-offset-[-2px]"
				placeholder=""
				value={data.case_stage}
			/>
		),
		footLabel: "",
		footClassName: "",
	},
	/*{
		id: "location",
		label: "Location",
		headerClassName: "",
		cellClassName: "",
		cell: ({ data }) => data.location,
		footLabel: "",
		footClassName: "",
	},
	{
		id: "case_age",
		label: "Age",
		headerClassName: "",
		cellClassName: "",
		cell: ({ data }) => data.case_age,
		footLabel: "",
		footClassName: "",
	},
	{
		id: "updated_at",
		label: "Updated",
		headerClassName: "text-left",
		cellClassName: " text-left",
		cell: ({ data }) => formatDate(data.updated_at),
		footLabel: "PHP 0.00",
		footClassName: "text-left",
	},*/
];

function Page() {
	return (
		<Content pageName="Table Cases">
			{/*<Header title="Table Cases" />*/}

			<div className="flex flex-col w-full max-w-[1200px] p-6">
				<div className="flex flex-col w-full rounded-md border border-border/50 mb-12">
					<DragDropFile />

					{/*<DataInputTable
            className="border-collapse"
            data={cases}
            columns={columns}
            stickyHead={false}
            stickyCol={false}
            showBorder={true}
            compact={true}
            showToolbar={false}
            showFooter={false}
            onEdit={() => {}}
            onRowClick={() => {}}
          />*/}
				</div>

				<div className="flex flex-col w-full gap-4">
					<div className="flex flex-col w-full rounded-md border border-border/50">
						<div className="flex flex-row w-full p-3 border-b border-border/50">
							<span className="text-base font-semibold text-foreground-dark">Data Input Table</span>
						</div>
						<div className="flex flex-col w-full">
							<DataInputTable
								className=""
								data={cases}
								columns={columns}
								stickyHead={false}
								stickyCol={false}
								showBorder={true}
								compact={true}
								onEdit={() => {}}
								onRowClick={() => {}}
							/>
						</div>
					</div>

					<div className="flex flex-col w-full rounded-md border border-border/50">
						<div className="flex flex-row w-full p-3 border-b border-border/50">
							<span className="text-base font-semibold text-foreground-dark">Scroll Table (maxHeight)</span>
						</div>
						<div className="flex flex-col w-full p-4">
							<DataTable
								className="border-collapse"
								data={cases}
								columns={columns}
								stickyHead={false}
								stickyCol={false}
								maxHeight={200}
								showBorder={false}
								compact={false}
								onEdit={() => {}}
								onRowClick={() => {}}
							/>
						</div>
					</div>

					<div className="flex flex-col w-full rounded-md border border-border/50">
						<div className="flex flex-row w-full p-3 border-b border-border/50">
							<span className="text-base font-semibold text-foreground-dark">Sticky Head (stickyHead)</span>
						</div>
						<div className="flex flex-col w-full p-4">
							<DataTable
								className="border-collapse"
								data={cases}
								columns={columns}
								stickyHead={true}
								stickyCol={false}
								maxHeight={200}
								showBorder={false}
								compact={false}
								onEdit={() => {}}
								onRowClick={() => {}}
							/>
						</div>
					</div>

					<div className="flex flex-col w-full rounded-md border border-border/50">
						<div className="flex flex-row w-full p-3 border-b border-border/50">
							<span className="text-base font-semibold text-foreground-dark">Sticky First Column (stickyCol)</span>
						</div>
						<div className="flex flex-col w-full p-4">
							<DataTable
								className="border-collapse"
								data={cases}
								columns={columns}
								stickyHead={true}
								stickyCol={true}
								maxHeight={200}
								showBorder={false}
								compact={false}
								onEdit={() => {}}
								onRowClick={() => {}}
							/>
						</div>
					</div>

					<div className="flex flex-col w-full rounded-md border border-border/50">
						<div className="flex flex-row w-full p-3 border-b border-border/50">
							<span className="text-base font-semibold text-foreground-dark">Enable Outside Border (showBorder)</span>
						</div>
						<div className="flex flex-col w-full p-4">
							<DataTable
								className="border-collapse"
								data={cases}
								columns={columns}
								stickyHead={true}
								stickyCol={true}
								maxHeight={200}
								showBorder={true}
								compact={false}
								onEdit={() => {}}
								onRowClick={() => {}}
							/>
						</div>
					</div>

					<div className="flex flex-col w-full rounded-md border border-border/50">
						<div className="flex flex-row w-full p-3 border-b border-border/50">
							<span className="text-base font-semibold text-foreground-dark">Mini Size (compact)</span>
						</div>
						<div className="flex flex-col w-full p-4">
							<DataTable
								className="border-collapse"
								data={cases}
								columns={columns}
								stickyHead={true}
								stickyCol={true}
								maxHeight={200}
								showBorder={true}
								compact={true}
								onEdit={() => {}}
								onRowClick={() => {}}
							/>
						</div>
					</div>

					<div className="flex flex-col w-full rounded-md border border-border/50">
						<div className="flex flex-row w-full p-3 border-b border-border/50">
							<span className="text-base font-semibold text-foreground-dark">Enable Footer (showFooter)</span>
						</div>
						<div className="flex flex-col w-full p-4">
							<DataTable
								className="border-collapse"
								data={cases}
								columns={columns}
								stickyHead={true}
								stickyCol={true}
								maxHeight={200}
								showBorder={true}
								compact={true}
								showFooter={true}
								/*customFooter={
                  <div className="flex flex-row justify-between w-full">
                    <span className="font-bold text-foreground-dark">AAAA</span>
                    <span className="">AAAA</span>
                  </div>
                }*/
								onEdit={() => {}}
								onRowClick={() => {}}
							/>
						</div>
					</div>

					<div className="flex flex-col w-full rounded-md border border-border/50">
						<div className="flex flex-row w-full p-3 border-b border-border/50">
							<span className="text-base font-semibold text-foreground-dark">Enable Custom Footer (customFooter)</span>
						</div>
						<div className="flex flex-col w-full p-4">
							<DataTable
								className="border-collapse"
								data={cases}
								columns={columns}
								stickyHead={true}
								stickyCol={false}
								showBorder={false}
								compact={true}
								showFooter={false}
								customFooter={
									<div className="flex flex-row justify-between w-full">
										<span className="font-bold text-foreground-dark">Total</span>
										<span className="font-bold text-foreground-dark">PHP 0.00</span>
									</div>
								}
							/>
						</div>
					</div>
				</div>
			</div>
		</Content>
	);
}
